import { Link, useLocation } from "react-router-dom";
import { sourceCodeList } from '../config/constant'
export default function SideBar() {
    let location = useLocation();
    return (
        <>
            <div className="p-2 text-white fixed sideColor" style={{
                width: "240px",
                height: "100%",
                position: " fixed",
                zIndex: "1",
                overflowX: "hidden",
            }}>

                <ul className="nav nav-pills flex-column mb-auto mx-2" style={{
                    paddingBottom: "100px"
                }}>
                    {sourceCodeList.map((elements, index) => {
                        return (
                            elements.type ? (
                                <>
                                    <button className="btn nav-item text-start collapsed text-white my-2" data-bs-toggle="collapse"
                                        data-bs-target={`#${elements.typeId}-collapse`} aria-expanded="true">
                                        {elements.typeName}
                                        <i className="bi bi-caret-down-fill pull-right"></i>
                                    </button>
                                    <div className="collapse" id={`${elements.typeId}-collapse`}>
                                        <ul className="btn-toggle-nav list-group" style={{
                                            listStyle: "none"
                                        }}>
                                            {elements.subs.map((element, indexs) =>
                                                <li className="nav-item mb-2" >
                                                    <Link key={indexs} to={element.path} className={`nav-link ${location.pathname === element.path ? 'active bg-dark' : "text-white"}`} >
                                                        <i class="bi bi-caret-right-fill"></i>
                                                        {element.component_name}
                                                    </Link>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </>
                            ) : (
                                <li className="nav-item mb-3" >
                                    <Link key={index} to={elements.path} className={`nav-link ${location.pathname === elements.path ? 'active bg-dark' : "text-white"}`} >
                                        {elements.component_name}
                                    </Link>
                                </li>
                            )
                        )

                    })}
                </ul>


            </div>
        </>
    )
}